import React from 'react';

const Menu = ({ setScreen, screen }) => {

    //highlight Orders with notification indicator if the user has any new "dispatch.order" notifications

    return <>
        <nav>
            <button style={{ fontWeight: screen == "Orders" ? 900 : 400, border: 0, background: "#fff", padding: 0, paddingRight: 10 }} onClick={() => setScreen("Orders")}>Orders</button>
            <button style={{ fontWeight: screen == "Vendors" ? 900 : 400, border: 0, background: "#fff", padding: 0, paddingRight: 10 }} onClick={() => setScreen("Vendors")}>Vendors</button>
            <button style={{ fontWeight: screen == "Drivers" ? 900 : 400, border: 0, background: "#fff", padding: 0, paddingRight: 10 }} onClick={() => setScreen("Drivers")}>Drivers</button>
            <button style={{ fontWeight: screen == "Reports" ? 900 : 400, border: 0, background: "#fff", padding: 0, paddingRight: 10 }} onClick={() => setScreen("Reports")}>Reports</button>
            <button style={{ fontWeight: screen == "Settings" ? 900 : 400, border: 0, background: "#fff", padding: 0, paddingRight: 10 }} onClick={() => setScreen("Settings")}>Settings</button>
        </nav>
    </>;
}
export default Menu;